import React from 'react'
import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'

const PublicLayout = ({ children }) => {
    return (
        <>
            <div className='main-wrapper'>
                <Header />
                {children}
                <Footer />
            </div>
        </>
    )
}

export default PublicLayout